import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '依赖',
    type: 'SSINS_DEPENDENCE_ON',
}
